import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectRootAssetIdFragment = { __typename?: 'Project', id: string, rootAssetId: string };

export const ProjectRootAssetId = /*#__PURE__*/ gql`
    fragment ProjectRootAssetId on Project {
  id
  rootAssetId
}
    ` as unknown as DocumentNode<ProjectRootAssetIdFragment, unknown>;

        

        
export const useProjectRootAssetIdFragment = (
  input: string | Omit<UseFragmentOptions<ProjectRootAssetIdFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<ProjectRootAssetIdFragment>({
    fragment: ProjectRootAssetId,
    fragmentName: 'ProjectRootAssetId',
    ...options,
  });
};
  
        